import type { PageProps } from '@inertiajs/core'
import { Link, router, usePage } from '@inertiajs/react'
import { type ReactNode, useEffect } from 'react'
import { toast } from 'sonner'
import { Toaster } from '@/components/ui/sonner'

interface SharedProps extends PageProps {
  flash: { notice: string | null; alert: string | null }
}

export default function AppLayout({ children }: { children: ReactNode }) {
  const { flash } = usePage<SharedProps>().props

  useEffect(() => {
    if (flash.notice) toast.success(flash.notice)
    if (flash.alert) toast.error(flash.alert)
  }, [flash.notice, flash.alert])

  return (
    <div className="mx-auto min-h-screen max-w-2xl px-5 py-7 sm:px-6">
      <header className="mb-10 flex items-baseline justify-between border-b border-border/70 pb-4">
        <Link
          href="/"
          className="font-display text-xl font-semibold tracking-tight text-foreground"
        >
          Tradmusic
        </Link>
        <div className="flex items-baseline gap-5">
          <Link
            href="/tunes"
            className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground transition-colors hover:text-foreground"
          >
            The book
          </Link>
          <Link
            href="/sets"
            className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground transition-colors hover:text-foreground"
          >
            Sets
          </Link>
          <button
            type="button"
            onClick={() => router.delete('/logout')}
            className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground transition-colors hover:text-foreground"
          >
            Log out
          </button>
        </div>
      </header>
      <main>{children}</main>
      <Toaster richColors position="top-center" />
    </div>
  )
}
